<header class="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
  <div class="flex items-center gap-4">
    @if (organizations().length > 0) {
      <label for="organization-select" class="sr-only">Organization</label>
      <select
        id="organization-select"
        [ngModel]="appStore.selectedOrganizationId()"
        (ngModelChange)="onOrganizationChange($event)"
        name="organizationSelect"
        [disabled]="isOnUpsertPage()"
        class="h-9 rounded-lg border-gray-200 bg-gray-50 text-sm focus:border-primary-500 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed">
        <option value="">Select Organization</option>
        @for (org of sortedOrganizations(); track org.id) {
          <option [value]="org.id">{{ org.name }}</option>
        }
      </select>
    }

    <label for="facility-select" class="sr-only">Facility</label>
    <select
      id="facility-select"
      [ngModel]="appStore.selectedFacilityId()"
      (ngModelChange)="onFacilityChange($event)"
      name="facilitySelect"
      [disabled]="!appStore.selectedOrganizationId() || isOnUpsertPage()"
      class="h-9 rounded-lg border-gray-200 bg-gray-50 text-sm focus:border-primary-500 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed">
      <option value="">{{ appStore.selectedOrganizationId() ? 'Select Facility' : 'Organization Required' }}</option>
      @for (facility of facilities(); track facility.id) {
        <option [value]="facility.id">{{ facility.name }}</option>
      }
    </select>
  </div>

  <div class="flex items-center gap-3">
    @if (chatManager.status()?.isEnabled) {
      <button
        type="button"
        (click)="toggleMessagesFlyout()"
        class="relative flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 transition-colors"
        [class.bg-primary-50]="chatManager.isFlyoutOpen()"
        title="Messages">
        <app-icon name="chat-bubble-left" size="md" />
        Messages
        @if (chatManager.hasUnreadAnywhere()) {
          <span class="absolute right-1.5 top-1.5 h-2.5 w-2.5 rounded-full bg-danger-400" data-unread-dot>
            <span class="sr-only">Unread messages</span>
          </span>
        }
      </button>
    }
    <button
      (click)="logout()"
      class="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
      title="Logout">
      <app-icon name="arrow-right-on-rectangle" size="md" />
    </button>
  </div>
</header>
